import React from "react";

const DashBoardProducts = () => {
  return (
    <div>
      <h1>hello dashboard products</h1>
    </div>
  );
};

export default DashBoardProducts;
